import React, { Component } from 'react';

import HeroSection from './HeroSection/HeroSection';

export default class PrivacyPolicy extends Component {
  static propTypes = {};
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <div style={{ marginTop: '66px' }}>
          <HeroSection
            title="Políticas de privacidad"
            description="Home  /  Políticas de privacidad"
            height="40vh"
            heroImage="/images/privacy-policies/privacy-policies-banner.jpg"
          />
        </div>

        <div
          className="pages-privacy-policy content-container font11"
          style={{ marginBottom: '40px' }}
        >
          <div className="pullman-section-primary-row">
            <div className="pullman-section-primary-row-main-heading black-text margin-T30">
              Políticas de privacidad
            </div>
            <div className="pullman-section-primary-row-underline margin-B35"></div>
          </div>
          <div className="pages-privacy-policy__row">
            Para utilizar a plenitud todos los servicios del sitio debe ser necesario registrarse y
            proveer cierta información personal que servirá para dar respuesta y otorgar un mejor
            servicio. Al aceptar los Términos y Condiciones, el usuario accede a proveer los datos
            para registro y las actualizaciones necesarias para mantener actualizado dicho registro.
            La institución utilizará los datos de registro de acuerdo con las disposiciones legales
            vigentes contenidas en la Ley N° 19.628 y sus modificaciones.
          </div>
          <div className="pages-privacy-policy__row">
            Estas políticas de privacidad rigen el uso que toda persona natural o jurídica que
            denominaremos “Cliente” le da a la plataforma y las condiciones de seguridad y
            tratamiento que se le da a los datos recopilados.
          </div>
          <div className="pages-privacy-policy__row">
            Establece las condiciones de recopilación, utilización y situación donde es compartida
            dicha información y los derechos que tiene el “Cliente” sobre la misma, sin hacer
            diferencia si ha sido usado a través de aplicación web de escritorio o móvil.
          </div>
          <div className="pages-privacy-policy__row">
            Para los efectos de la presente Política de Privacidad, el Cliente expresa su aceptación
            plena de las cláusulas aquí descritas, por tanto, constituye un acuerdo válido y
            obligatorio entre Cliente y Pullman Bus.
          </div>
          <div className="pages-privacy-policy__row">
            En caso de que el Usuario no acepte las condiciones o no esté de total acuerdo con las
            Política de Privacidad, deberá dejar de usar la Plataforma y abstenerse de descargar o
            usar ya sea directa o indirectamente, y de utilizar cualquier servicio provisto por la
            misma. Constituye igualmente responsabilidad del Cliente revisar periódicamente la
            Política de Privacidad de la Plataforma y ver sus actualizaciones o modificaciones.
          </div>

          <div className="pages-privacy-policy__row">
            Para el funcionamiento de la Plataforma, la Empresa puede recopilar información web así
            como grabar las llamadas telefónicas que se estimen conveniente especialmente en caso de
            gestión de reclamos. También se podrá almacenar información de los Usuarios, por medio
            de cookies o tag, por medio de la información proporcionada por el propio Cliente. Dicha
            información comprende datos referentes como nombre, direcciones, correo electrónico,
            direcciones IP, navegador o búsquedas realizadas en nuestra Plataforma. El Cliente podrá
            optar a su libre elección, restringir o deshabilitar el uso de cookies configurando su
            navegador web de preferencia, habilitando su navegador web para que rechace cookies
            teniendo en cuenta que al negarse a aceptar una cookie no podrá obtener acceso a muchos
            servicios de viaje y herramientas de planificación ofrecidos por este Sitio Web.
          </div>

          <div className="pages-privacy-policy__row">
            <strong>La información y datos que se recopila se le da el siguiente uso:</strong>
          </div>
          <div className="pages-privacy-policy__row__sub">
            <span></span> Tramitar su compra de pasaje incluyendo las transacciones.
          </div>
          <div className="pages-privacy-policy__row__sub">
            <span></span> Ofrecerle productos, descuentos o promociones a través de medios como
            correo electrónico o teléfono.
          </div>
          <div className="pages-privacy-policy__row__sub">
            <span></span> Responder preguntas y gestionar reclamos, realizar encuestas de
            satisfacción, o consultar preferencia de ofertas o destinos.
          </div>
          <div className="pages-privacy-policy__row__sub">
            <span></span> Remitirle confirmación y actualizaciones sobre su compra vía correo
            electrónico, teléfono, SMS o WhatsApp.
          </div>
          <div className="pages-privacy-policy__row__sub mb-20">
            <span></span> Realizar análisis y estudios internos de Pullman Bus, sobre intereses,
            gustos y necesidades del cliente, con el fin de mejorar nuestras propuestas comerciales,
            publicitarias y promocionales.
          </div>
          <div className="pages-privacy-policy__row">
            Queda entendido y es de su conocimiento que Pullman Bus podrá compartir los datos
            relevantes de sus usuarios con Prestadoras de Servicio de transporte, aliados
            comerciales y proveedores para la gestión de sus reservas, incluyendo tarjetas de
            crédito usadas en la compra, analítica comercial y servicio de atención al cliente.
          </div>
          <div className="pages-privacy-policy__row">
            Pullman Bus mantiene mecanismos de seguridad para protección de sus datos, haciendo uso
            de un título digital que autentifica la identidad de un sitio web y cifrado de datos con
            el protocolo SSL (Secure Socket Layer), por lo que la información que se envía al
            servidor será estrictamente confidencial para el uso de terceros. Los datos serán de uso
            exclusivo para aquellos empleados, contratistas, representantes y agentes de la Empresa
            que necesitan conocer tales datos para el desempeño sus funciones y exigiendo a
            proveedores y aliados comerciales las mismas condiciones de confidencialidad incluyendo
            a empresas. Sin embargo y sin perjuicio de lo anterior, no garantiza eventuales
            vulneraciones por ataques web o intromisión de terceros no autorizados, aun cuando
            utilicen la información de los Clientes en forma indebida. Pullman Bus se reserva el
            derecho de transferir la información recolectada en caso de venta de todo o parte de la
            compañía o transferencia de la Plataforma a otro administrador.
          </div>
          <div className="pages-privacy-policy__row">
            Los datos personales correspondientes al Cliente serán almacenados en servidores
            ubicados en Chile, sin embargo, podrá almacenar dichos datos en otras ubicaciones fuera
            de Chile, a efecto de respaldos o redundancia de almacenamiento.
          </div>
          <div className="pages-privacy-policy__row">
            El cliente al momento de registrarse o hacer transacciones bancarias podrá optar por
            aceptar o denegar la recepción en su correo electrónico de circulares promocionales,
            mensajes o alertas de ofertas, teniendo la posibilidad de cancelar suscripción a través
            de enlace que será enviado en cada correo electrónico. En caso de cancelación de
            suscripción dejará de recibir alertas de ofertas, mensajes promocionales o descuentos
            especiales pero continuará recibiendo comunicaciones referidas al estatus de sus
            reservas activas. El usuario podrá solicitar la cancelación, rectificación, o supresión
            total de su información personal, a través de carta certificada enviada a WIT dirección
            Los Conquistadores 2440, Providencia, Santiago de Chile, lo cual deberá ser atendido en
            un plazo no mayor a 20 días hábiles para proceder a la eliminación total de los datos.
          </div>
          <div className="pages-privacy-policy__row">
            PullmanBus.cl es mantenido y gestionado por{' '}
            <a href="https://kupos.cl/" target="_blank">
              <strong>kupos.cl</strong>
            </a>
          </div>

          <div className="pages-privacy-policy__row">
            <strong>
              EL USUARIO DECLARA FORMALMENTE CONOCER Y ACEPTAR ESTA POLÍTICA DE PRIVACIDAD Y LOS
              DERECHOS QUE OTORGA A Pullman Bus.
            </strong>
          </div>
          <div className="pages-privacy-policy__row">
            <strong>
              ¿Cómo puedes controlar los datos personales que has ingresado en Pullmanbus.cl?
            </strong>
          </div>
          <div className="pages-privacy-policy__row">
            Como usuario tienes derecho a revisar los datos que mantiene pullmanbus.cl sobre ti, en
            cualquier momento. En caso de que tengas una solicitud de revisión sobre la privacidad
            de tus datos, así como de eliminar o acceder a tu información, debes enviar un correo a
            viajes@pullmanbus.cl. Una vez sea enviada la solicitud, nuestro equipo de privacidad se
            comunicará directamente para asistir en la solicitud. Consultas generales de privacidad
            de datos o cualquier otra relacionada a las Políticas de Privacidad y Cookies, deben ser
            dirigidas a viajes@pullmanbus.cl.
          </div>

          <div className="pages-privacy-policy__row">
            <strong>
              ¿Qué tipo de datos o información personal guarda pullmanbus.cl y por qué?
            </strong>
          </div>
          <div className="pages-privacy-policy__row">
            Pullmanbus.cl no puede ofrecerte la mejor alternativa de viaje sin información, por lo
            que al usar nuestros servicios, hay algunos datos que te pedimos. Los datos solicitados
            son información típica o de rutina: tu nombre, datos de contacto, los nombres de las
            personas que viajan contigo y, en algunos escenarios, tu información de pago.
          </div>
          <div className="pages-privacy-policy__row">
            Adicionalmente a esto, también recopilamos información acerca del dispositivo
            (computador, teléfono, tablet u otro) que utilices para acceder a nuestros servicios.
            Esto incluye la dirección IP, el navegador que utilizas, el ID de tu teléfono y tus
            preferencias de idioma o lenguaje. También, y dependiendo de los servicios, también
            permites a pullmanbus.cl que recopilemos la siguiente información: tu foto de perfil,
            género, fecha de nacimiento. Algunas de las llamadas o comunicaciones escritas que hagas
            a nuestros canales de atención podrían ser grabadas con motivo de capacitación y
            supervisión; así como cualquier información extraordinaria que hayas decidido compartir
            con nosotros al momento de usar nuestros servicios, como tu ubicación, calendario y
            otros.
          </div>
          <div className="pages-privacy-policy__row">
            El principal objetivo detrás de la recolección de estos datos es únicamente el mejorar y
            ofrecerte una experiencia más amigable en pullmanbus.cl, en cualquiera de sus versiones.
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/pages/PrivacyPolicy.js